export const getCookie = (name: string): string | null => {
  let cookieValue = null;
  if (typeof document !== 'undefined') {
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + '=') {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
  return '';
};

type SupportedCookies = 'whatsNewPopupClosed' | 'locale' | 'showDocsInReview';

export function setCookie(
  name: SupportedCookies,
  value: string | boolean,
  expires?: Date,
) {
  const expiresProperty = expires ? `; expires=${expires.toUTCString()}` : '';
  document.cookie = `${name}=${value}${expiresProperty}`;
}

/** @knipignore */
export function deleteCookie(name: SupportedCookies) {
  document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
}
